import { useMemo } from 'react'
import InputTableLeftColumnForm from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { getAllCurrencies, getSellVariables } from '../../../../../../../utils/reducers/getters'
import { SellVariableTypeInversed } from '@teinor/erp/types/company/config/sellVariable'
import ITHeaderText from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'

interface BuyReadOnlyHeaderVariablesProps extends InputTableLeftTabsProps { }

const BuyReadOnlyHeaderVariables: React.FC<BuyReadOnlyHeaderVariablesProps> = ({ headerData, handleChange }) => {
    const { t } = useTwinTranslation()
    const dictVariables = useMemo(() => getSellVariables() || {}, [])
    const currencies = getAllCurrencies()
    const variables = headerData.OrderVariables
    const currencyHeaderId = headerData.CurrencyId
    const sections: FormRender<any> = [{
        title: t('variables', 'Variables'),
        cols: 1,
        elements: []
    }]
    if (variables) {
        for (let key in variables) {
            const variable = variables[key]
            sections[0].elements.push({
                name: variable.OrderVariableId + '_key_' + key,
                component: 'Custom',
                render: () => <ITHeaderText label={dictVariables?.[variable.OrderVariableId]?.name} value={variable.value || '' + (dictVariables?.[variable.OrderVariableId].type === SellVariableTypeInversed['price'] ? ' ' + currencies[currencyHeaderId]?.symbolNative : '')} />,
            })
        }
    }
    return (
        <InputTableLeftColumnForm form={sections} handleChange={handleChange} headerData={headerData} />
    )
}


export default BuyReadOnlyHeaderVariables